import { useState, useEffect, useRef, ChangeEvent, KeyboardEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@habitech/ui-button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';

import { IComparableRow } from '../../types';
import { useCompsData } from './hooks/useCompsData';
import {
  Wrapper,
  Card,
  Header,
  Title,
  Subtitle,
  Section,
  SectionLabel,
  ErrorText,
  BackButton,
  InputGroup as StyledInputGroup,
} from './styles';

interface NidSearchProps {
  onLoad: (data: {
    nid: string;
    subjectLat: number | null;
    subjectLng: number | null;
    rows: IComparableRow[];
  }) => void;
}

export const NidSearch = ({ onLoad }: NidSearchProps) => {
  const navigate = useNavigate();
  const [nid, setNid] = useState('');
  const nidRef = useRef('');
  const { rows, loading, error, fetchComps, reset } = useCompsData();

  const onLoadRef = useRef(onLoad);
  onLoadRef.current = onLoad;

  useEffect(() => {
    if (rows && rows.length > 0) {
      onLoadRef.current({
        nid: nidRef.current,
        subjectLat: rows[0].latitude ?? null,
        subjectLng: rows[0].longitude ?? null,
        rows,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  const handleNidChange = (e: ChangeEvent<HTMLInputElement>) => {
    setNid(e.target.value);
    reset();
  };

  const handleSearch = () => {
    const trimmed = nid.trim();
    if (!trimmed) return;
    nidRef.current = trimmed;
    fetchComps(trimmed);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <Wrapper>
      <Card>
        <BackButton onClick={() => navigate(-1)}>← Volver</BackButton>
        <Header>
          <Title>Visualizador Manual</Title>
          <Subtitle>
            Ingresa el NID del inmueble. Obtendremos sus coordenadas y los
            comparables utilizados en el ejercicio de pricing manual.
          </Subtitle>
        </Header>

        <Section>
          <SectionLabel>NID del inmueble</SectionLabel>
          <StyledInputGroup>
          <InputGroup>
            <FormControl
              placeholder="Ej: 57029715084"
              value={nid}
              onChange={handleNidChange}
              onKeyDown={handleKeyDown}
              isInvalid={!!error}
              disabled={loading}
            />
            <Button
              size="medium"
              variant="fill"
              onClick={handleSearch}
              disabled={!nid.trim() || loading}
            >
              {loading ? 'Consultando...' : 'Buscar'}
            </Button>
          </InputGroup>
          </StyledInputGroup>

          {error && <ErrorText>{error}</ErrorText>}
        </Section>
      </Card>
    </Wrapper>
  );
};
